module.exports = __webpack_public_path__ + "img/flowers_1.ca99d509.png";